<button [type]="type" [className]="value" [disabled]="disabled" (click)="click.emit()">
  {{ text }}
</button>
